var map = {
	"./img1.jpg": 2130,
	"./img10.jpg": 2131,
	"./img2.jpg": 2132,
	"./img3.jpg": 2133,
	"./img4.jpg": 2134,
	"./img5.jpg": 2135,
	"./img6.jpg": 2136,
	"./img7.jpg": 2137,
	"./img8.jpg": 2138,
	"./img9.jpg": 2139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2129;